import React from 'react'
import { Modal, Row } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import RequisitionsForm from '../../../components/Corporate/Requisitions/AddRequisitions/RequisitionsForm'

function RequisitionsModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    isUpdatable,
    isRemovable,
  } = props

  const isNew = modalType === 'new'

  return (
    <Modal
      visible={visible}
      title={'Requisitions'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          visible={isUpdatable || isNew}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Requisitions'}
          isNew={isNew}
          isEdit={!isNew}
          isRemovable={isRemovable}
        />
      }
      width={'75%'}>
      <Row>
        <RequisitionsForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

RequisitionsModal.propTypes = {}
RequisitionsModal.defaultProps = {}

export default RequisitionsModal
